import React from 'react'
import { Fade, Modal as MUIModal } from '@mui/material'

import { StyledPaper } from './styles'

const Modal = ({
  children,
  open,
  onClose,
  PaperProps,
  closeButton,
  ...props
}) => {
  if (!open) {
    return null
  }

  return (
    <MUIModal
      open={open}
      onClose={onClose}
      slotProps={{ timeout: 250, style: { backdropFilter: 'blur(10px)' } }}
      {...props}
    >
      <Fade in={open}>
        <StyledPaper {...PaperProps}>{children}</StyledPaper>
      </Fade>
    </MUIModal>
  )
}

export default Modal
